var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearDuplicateIcon = function SvgClearDuplicateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14194_17372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49143 11.72H4.24571C3.55772 11.72 3 11.1623 3 10.4743V4.24571C3 3.55772 3.55772 3 4.24571 3H10.4743C11.1623 3 11.72 3.55773 11.72 4.24571V5.49143",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14194_17372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.5L8.5 16.5",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.501L8.5 8.50098",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14194_17372"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -7,
    width: 34,
    height: 34,
    rx: 7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14194_17372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
export { SvgClearDuplicateIcon as ReactComponent };
export default __webpack_public_path__ + "clear-duplicate-icon.svg";